const findColumnRowNumber = (column, row) => {
  return `${column}x${row}`;
};

export default findColumnRowNumber;
